export const colorMainDark = '#374856';
export const colorMainLight = '#304451';
export const colorOverflowBg = '#304352';
export const colorText = '#e2e2e2';
export const colorHeadingText = '#f0f0f0';
export const colorWhiteBg = '#f0f0f0';
export const colorMainButton = '#e44c65';

export const maxContentWidth = '1400px';
export const maxGridWidth = '1100px';
export const maxTextWidth = '1200px';



// WEBPACK FOOTER //
// ./src/styles/variables.js